import React from 'react';

type Props = {
  title: React.ReactNode;
};

const PageTitleBar = ({ title }: Props): JSX.Element => (
  <div className={'w-full mx-auto py-2 bg-white'} data-hide-print>
    <div className={'relative flex items-center justify-center max-w-screen-xl container bg-white py-2 md:py-2'}>
      <div className={'p-1 border-b-4 border-header'}>
        <b className={'text-xl lg:text-2xl'}>{title}</b>
      </div>
    </div>
  </div>
);

PageTitleBar.displayName = 'PageTitleBar';

export default PageTitleBar;
